import React from 'react';
import Icon from '../../Icon';
import TextSmall from '../../Typography/TextSmall';

function ProductCardRating({ currentRating = 0, ratingCount = 0 }) {
  return (
    <div className="flex items-center mt-4 sm:mt-0">
      <Icon
        type="star-gold-outline-fill"
        className="size-[20px] lg:size-[24px]"
      />
      <TextSmall
        text={
          Number(currentRating) === 0
            ? '0/5'
            : `${
                String(currentRating).includes('.')
                  ? Number(currentRating).toFixed(1)
                  : currentRating
              }/5`
        }
        className="text-senate font-medium mr-4 ml-6 lg:mr-4 lg:ml-11"
      />

      <TextSmall
        text={`(${ratingCount})`}
        className="!text-xss lg:!text-sm text-senate font-semibold lg:font-medium"
      />
    </div>
  );
}

export default ProductCardRating;
